// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/Opengraph/MetatagsCards/Metadata.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/Opengraph/MetatagsCards/Metadata.tsx");
  import.meta.hot.lastModified = "1717182690460.3628";
}
// REMIX HMR END

import { Table, TableBody, TableCell, TableRow } from "~/components/ui/table";
export function Metadata({
  title,
  description,
  image,
  origin,
  url,
  favicon
}) {
  return <Table>
      <TableBody>
        <TableRow>
          <TableCell className="py-6 font-bold">Title</TableCell>
          <TableCell className="py-6 break-words">{title}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="py-6 font-bold">Description</TableCell>
          <TableCell className="py-6">
            <div dangerouslySetInnerHTML={{
            __html: description || ""
          }} className="break-words" />
          </TableCell>
        </TableRow>
        {image && <TableRow>
            <TableCell className="py-6 font-bold">Image</TableCell>
            <TableCell className="py-6">
              <div dangerouslySetInnerHTML={{
            __html: image
          }} className="break-all" />
            </TableCell>
          </TableRow>}
        {origin && <TableRow>
            <TableCell className="py-6 font-bold">Origin</TableCell>
            <TableCell className="py-6">
              <div dangerouslySetInnerHTML={{
            __html: origin
          }} className="break-all" />
            </TableCell>
          </TableRow>}
        {url && <TableRow>
            <TableCell className="py-6 font-bold">Url</TableCell>
            <TableCell className="py-6">
              <div dangerouslySetInnerHTML={{
            __html: url
          }} className="break-all" />
            </TableCell>
          </TableRow>}
        {favicon && <TableRow>
            <TableCell className="py-6 font-bold">Favicon</TableCell>
            <TableCell className="py-6">
              <div dangerouslySetInnerHTML={{
            __html: favicon
          }} className="break-all" />
            </TableCell>
          </TableRow>}
      </TableBody>
    </Table>;
}
_c = Metadata;
var _c;
$RefreshReg$(_c, "Metadata");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;